/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IntercomCredentials,
  IntercomCredentials$inboundSchema,
  IntercomCredentials$Outbound,
  IntercomCredentials$outboundSchema,
} from "./intercomcredentials.js";
import {
  IntercomData,
  IntercomData$inboundSchema,
  IntercomData$Outbound,
  IntercomData$outboundSchema,
} from "./intercomdata.js";

export type PublicIntercomConnection = {
  provider: "intercom";
  data: IntercomData;
  credentials: IntercomCredentials;
};

/** @internal */
export const PublicIntercomConnection$inboundSchema: z.ZodType<
  PublicIntercomConnection,
  z.ZodTypeDef,
  unknown
> = z.object({
  provider: z.literal("intercom"),
  data: IntercomData$inboundSchema,
  credentials: IntercomCredentials$inboundSchema,
});
/** @internal */
export type PublicIntercomConnection$Outbound = {
  provider: "intercom";
  data: IntercomData$Outbound;
  credentials: IntercomCredentials$Outbound;
};

/** @internal */
export const PublicIntercomConnection$outboundSchema: z.ZodType<
  PublicIntercomConnection$Outbound,
  z.ZodTypeDef,
  PublicIntercomConnection
> = z.object({
  provider: z.literal("intercom"),
  data: IntercomData$outboundSchema,
  credentials: IntercomCredentials$outboundSchema,
});

export function publicIntercomConnectionToJSON(
  publicIntercomConnection: PublicIntercomConnection,
): string {
  return JSON.stringify(
    PublicIntercomConnection$outboundSchema.parse(publicIntercomConnection),
  );
}
export function publicIntercomConnectionFromJSON(
  jsonString: string,
): SafeParseResult<PublicIntercomConnection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PublicIntercomConnection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PublicIntercomConnection' from JSON`,
  );
}
